<nav class="head-nav" [class]="customClass">
  <div class="nav-container">
    <div>
      <h2>{{currentView || (navBreadcrumb.length ? navBreadcrumb[navBreadcrumb.length - 1].title : '')}}</h2>

      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
        </li>

        <li class="breadcrumb-item" *ngIf="hasRestaurant && restaurantData?.name">
          <a class="breadcrumb-restaurant-name"
            [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
        </li>


        <li class="breadcrumb-item" *ngFor="let item of navBreadcrumb; index as i">
          <ng-container *ngIf="i + 1 == navBreadcrumb.length && isParentLink; else title">
            <a [routerLink]="[item.state]" [queryParams]="queryParams">{{item.title}}</a>
          </ng-container>
          <ng-template #title>{{item.title}}</ng-template>
        </li>

        <li class="breadcrumb-item" *ngIf="childViewTitle">
          {{childViewTitle}}
        </li>
      </ol>
    </div>

    <ng-container *ngIf="hasBranshes">
      <div [hidden]="hideBranshes">
        <app-restaurants-dropdown (all)="branchChanged($event)" (ownRests)="ownRests.emit($event)"
          (isChanged)="isChanged.emit(true)"></app-restaurants-dropdown>
      </div>
    </ng-container>

  </div>
</nav>
